import React, { Component } from 'react'
import GoogleAnalytics from 'react-ga'
import { RouteComponentProps } from 'react-router-dom'

const GAID = process.env.GAID

if (GAID) {
  GoogleAnalytics.initialize(GAID)
}

const withTracker = (WrappedComponent: any, options = {}) => {
  const trackPage = (page: string) => {
    if (!GAID) {
      return
    }

    GoogleAnalytics.set({
      page,
      ...options
    })
    GoogleAnalytics.pageview(page)
  }

  const BASENAME = process.env.APP_BASENAME || ''

  const HOC = class extends Component<RouteComponentProps> {
    componentDidMount() {
      const page = this.props.location.pathname + this.props.location.search
      trackPage(`${BASENAME}${page}`)
    }

    componentDidUpdate(prevProps: RouteComponentProps) {
      const currentPage =
        prevProps.location.pathname + prevProps.location.search
      const nextPage =
        this.props.location.pathname + this.props.location.search

      if (currentPage !== nextPage) {
        trackPage(`${BASENAME}${nextPage}`)
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  return HOC
}

export default withTracker
